var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiringberbagi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10H12.5C13.878 10 15 8.879 15 7.5V2.5C15 1.121 13.878 0 12.5 0H5.5C4.122 0 3 1.121 3 2.5V7.5C3 8.879 4.122 10 5.5 10ZM4 2.5C4 1.673 4.673 1 5.5 1H12.5C13.327 1 14 1.673 14 2.5V7.5C14 8.327 13.327 9 12.5 9H5.5C4.673 9 4 8.327 4 7.5V2.5ZM7 3.5C7 3.224 7.224 3 7.5 3H10.5C10.776 3 11 3.224 11 3.5C11 3.776 10.776 4 10.5 4H7.5C7.224 4 7 3.776 7 3.5ZM23.181 9.654C22.684 9.203 22.038 8.967 21.372 9.003C20.702 9.034 20.084 9.324 19.633 9.82L15.901 13.923C15.587 12.815 14.566 12 13.359 12H3.5C1.57 12 0 13.57 0 15.5V20.5C0 22.43 1.57 24 3.5 24H9.465C12.171 24 14.757 22.841 16.558 20.82L23.364 13.18C24.274 12.158 24.193 10.576 23.181 9.654ZM22.618 12.514L15.812 20.154C14.2 21.963 11.887 23 9.465 23H3.5C2.122 23 1 21.879 1 20.5V15.5C1 14.121 2.122 13 3.5 13H13.358C14.263 13 15 13.737 15 14.643C15 15.455 14.394 16.154 13.601 16.267L7.44 17.004C7.166 17.036 6.97 17.285 7.003 17.56C7.037 17.833 7.277 18.04 7.559 17.997L13.73 17.259C14.752 17.113 15.576 16.381 15.876 15.435L20.371 10.496C20.643 10.197 21.015 10.022 21.418 10.004C21.816 9.983 22.208 10.125 22.506 10.396C23.114 10.952 23.164 11.903 22.616 12.517L22.618 12.514Z",
    fill: "#939393"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiringberbagi);
export default __webpack_public_path__ + "static/media/piringberbagi.342433783fb2125b70b11b576705dc61.svg";
export { ForwardRef as ReactComponent };